export enum ClearanceOutput {
    Cleared = 'Cleared',
    Duplicate = 'Duplicate',
    Error = 'Error',
    NotAppointed = 'NotAppointed',
}
